module.exports = __webpack_public_path__ + "static/img/menu-kc-light.c77f6d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-kc-light.png
// module id = LHBH
// module chunks = 2